<template>
  <div id="endereco">
    <h4>{{ item.rua }}, {{ item.numero }}</h4>
    <div id="subdados_endereco">
      <p>{{ item.bairro }}</p>
      <p>{{ item.cidade }}/{{ item.estado }}</p>
    </div>
    <div style="height: 1px; background-color: #EEE;margin-top: 10px; margin-bottom: 10px;" />
    <div id="acoes_endereco">
      <button type="button" id="delete_btn" v-on:click="removeEndereco()">
        <i class="material-icons" id="delete_icon">delete</i> Excluir
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Endereco",
  props: {
    item: {
      type: Object
    },
    updateItems: {
      type: Function
    }
  },
  methods: {
    removeEndereco() {
      let user = JSON.parse(localStorage.getItem("usuario"));
      this.$http
        .delete(
          `/projects/cliente/endereco/${user.cliente._id}/${this.item._id}`
        )
        .then(() => {
          //this.getEnderecos();
          if (this.updateItems) {
            this.updateItems();
          }
          this.$forceUpdate();
        })
        .catch(() => {});
    }
  }
};
</script>

<style>
#endereco {
  text-align: left;
  border: 1px solid #e4e4e4;
  border-radius: 3px;
  padding: 10px;
  width: 400px;
}

#endereco button {
}

#delete_icon {
  width: 30px;
  color: #666;
}

#delete_btn {
  display: flex;
  width: 90px;
  align-items: center;
  font-size: 14px;
}

#acoes_endereco button {
  color: #666;
}

#acoes_endereco{
  display: flex;
  justify-content: flex-end;
}

#subdados_endereco p {
  font-size: 14px;
}
</style>
